import {
  EcommerceSettings,
  EcommerceSettingsService as EcommerceSettingsServiceSdk,
} from '@wix/wixstores-client-storefront-sdk';
import {getPayableCurrencies} from '@wix/ambassador-cashier-pay-v2-account/http';
import type {ControllerFlowAPI} from '@wix/yoshi-flow-editor';

export class EcommerceSettingsService {
  private readonly ecommerceSettingsServiceSdk: EcommerceSettingsServiceSdk;
  private ecommerceSettings?: EcommerceSettings;
  private readonly flowAPI: ControllerFlowAPI;
  public hasCreatedPaymentMethods: boolean = true;

  constructor({
    ecommerceSettingsServiceSdk,
    flowAPI,
  }: {
    ecommerceSettingsServiceSdk: EcommerceSettingsServiceSdk;
    flowAPI: ControllerFlowAPI;
  }) {
    this.ecommerceSettingsServiceSdk = ecommerceSettingsServiceSdk;
    this.flowAPI = flowAPI;
  }

  public async init() {
    try {
      this.ecommerceSettings = await this.ecommerceSettingsServiceSdk.getEcommerceSettings();
    } catch {
      this.ecommerceSettings = undefined;
    }
  }
  public async initPayableCurrencies() {
    try {
      const payableCurrencies =
        (
          await this.flowAPI.errorHandler.withErrorHandler(
            () => this.flowAPI.essentials.httpClient.request(getPayableCurrencies({})),
            {errorCodesMap: {}}
          )
        ).data.currencyCode ?? /* istanbul ignore next */ [];
      this.hasCreatedPaymentMethods = payableCurrencies.length > 0;
    } catch {
      this.hasCreatedPaymentMethods = true;
    }
  }

  public getEcommerceSettings() {
    return (
      this.ecommerceSettings ?? {
        hasValidationsInCart: true,
        hasAdditionalFees: true,
        tax: {taxIncludedInItemPrices: false},
      }
    );
  }
}
